import React from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { startSetIncidenciaInterna } from "../../../../context/actions/incidenciasActions";

export const useIncidenciaInternaForm = () => {
  const dispatch = useDispatch();
  const [body, setBody] = React.useState({});
  const { asistenciaID } = useParams();

  const handleChange = (value) => {
    setBody({ motivoIncidencia: value });
  };

  const handleSubmit = () => {
    const post = {
      asistenciaID,
      motivoIncidencia: body.motivoIncidencia
    };
    dispatch(startSetIncidenciaInterna(post));
    setBody({});
  };

  return { body, handleChange, handleSubmit };
};
